import { unreadonly } from '../../../types/unreadonly';
import type { TableFilterBase } from '../TableFilter';
import { filterOperators } from '../operators';

const textFilterOperators = unreadonly([
  ...filterOperators.text,
  ...filterOperators.empty,
  ...filterOperators.regex,
  ...filterOperators.column,
  ...filterOperators.color,
  ...filterOperators.arrayContains,
] as const);

export type TextFilterOperator = (typeof textFilterOperators)[number];

export type TextTableFilter = TableFilterBase & {
  type: 'text';
};

export const createTextFilter = (): TextTableFilter => ({
  type: 'text',
  operators: textFilterOperators,
});
